import "jquery-ui/ui/widgets/draggable";
import { C } from "../common/component";
import { Collapse } from "../common/collapse";
import { Txt } from "../common/text";
import { TimesheetShortcutsSet } from "./timesheet-shortcuts-set";
import { TimesheetShortcut } from "./timesheet-models";
import { ButtonBuilder } from "../common/button-builder";
import { Tooltip } from "../common/tooltip";
import { StorageHelper, StorageItem } from "../common/storage-helper";

export class TimesheetShortcutsPanel
{
    private readonly panelParent;

    constructor(parent)
    {
        const buttonParent = C.buttonsGroup.css("margin-top", "21px").css("margin-left", "10px").appendTo(parent);
        this.panelParent = C.div.addClass("schedule").appendTo(parent);

        const toggleButton = ButtonBuilder.get({
            name: Txt.hideShortcuts
        }).appendTo(buttonParent);
        const setShortcutsVisibility = (show: boolean) =>
        {
            toggleButton.text(show ? Txt.hideShortcuts : Txt.showShortcuts);
            if (show)
            {
                Collapse.show(this.panelParent[0]);
            }
            else
            {
                Collapse.hide(this.panelParent[0]);
            }
        };
        let shown = !StorageHelper.get(StorageItem.hideTimesheetShortcuts);
        toggleButton.text(shown ? Txt.hideShortcuts : Txt.showShortcuts);
        Collapse.init(this.panelParent[0], shown);
        toggleButton.click( () =>
        {
            shown = !shown;
            StorageHelper.set(StorageItem.hideTimesheetShortcuts, !shown);
            setShortcutsVisibility(shown);
        });
    }

    set(shortcuts: TimesheetShortcutsSet)
    {
        this.panelParent.empty();
        const container = C.div.addClass("w-form-group").appendTo(this.panelParent);
        C.label.addClass("schedule-label").text(Txt.vactionAndShiftLegend).appendTo(container);

        for (const group of shortcuts.getDisplayGroups())
        {
            const abbreviations = C.div.css("margin-bottom", "5px").appendTo(container);
            for (const item of group.displayedShortcuts)
            {
                const titleSpan = this.addShortcut(item, abbreviations);
                if (item.Start || item.End)
                {
                    let tooltipText = "";
                    const addLine = (label: string, value: string) =>
                    {
                        if (value)
                        {
                            tooltipText += (tooltipText ? "<br>" : "") + `${label}: ${value}`
                        }
                    };

                    addLine(Txt.startTime, item.Start);
                    addLine(Txt.endTime, item.End);
                    if (item.LunchLength)
                    {
                        addLine(Txt.breakDuration, `${item.LunchLength} min`)
                    }
                    addLine(Txt.projects, item.ProjectNames);
                    addLine(Txt.workType, item.WorkTypeName);

                    Tooltip.attach(titleSpan[0], tooltipText, true);
                }
            }
        }
    }

    private addShortcut(item: TimesheetShortcut, parent)
    {
        const span = C.span.addClass("img-circle span-shortcut")
            .css("background-color", item.Color)
            .text(item.Abbreviation)
            .click(() => false)
            .draggable({ revert: "invalid", helper: "clone" });
        const titleSpan = C.span.text(` ${item.Name}`);
        C.div.addClass("w-button-primary")
            .css({ marginRight: "5px", padding: "1px 10px 1px 2px", borderRadius: "50px", cursor: "auto" })
            .append(span)
            .append(titleSpan)
            .appendTo(parent);
        return titleSpan;
    }
}
